import React, { Component } from 'react';
import XLSX from 'xlsx';
import { Button } from '../../../common/components/button/Button';
import { Col, Form, Row } from 'react-bootstrap'
import { Text } from '../../../common/components/text/Text'
import { Flex } from '../../../common/components/flex/Flex';
import Icons from '../../../common/components/icon/Icon';
import { Space } from '../../../common/components/space/Space';
import datalasticShipEngService from '../../../services/datalasticShipEngService'
import { make_cols } from '../pagecontainer/MakeColumns';
import { history } from '../../../store'
import swal from 'sweetalert';
import downloadicon from '../../../assets/images/XL.png';
import { Attributes } from '../../../common/components/attribute/Attribute';
import classNames from 'classnames';
import { Table } from '../../../common/components/table/Table'
import '../datalasticShipDemolation/datalastic.scss'
import Loader from 'react-loader-spinner'
import Modal from '../../../common/components/modal/Modal';
import { ModalBody } from '../../login/pagecontainer/ForgotPassWord';
import { Main } from '../../../common/components/main/Main';
import { Grid } from '../../../common/components/grid/Grid';
import Card from '../../../common/components/card/Card';
import { format, parseISO } from 'date-fns'

class DatalasticExcel extends Component<any, any> {

    constructor(props: any) {
        super(props);
        const { onClose } = props

        this.state = {
            file: {},
            data: [],
            cols: [],
            shows: false,
            files: false,
            number_of_dockType: 0,
            number_of_port: 0,
            number_of_city: 0,
            number_of_valid: 0,
            name: [],
            loading: false,
            actualFile: {}
        }
        this.handleFile = this.handleFile.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.uploadFile = this.uploadFile.bind(this);
    }

    handleChange(e: any) {
        const files = e.target.files;
        console.log(e.target.files[0]);
        this.setState({ actualFile: e.target.files[0] })
        if (files && files[0]) this.setState({ file: files[0], files: true });
    };

    handleShow(dock: any, res: any) {

    }

    handleFile() {
        if (this.state.files) {
            /* Boilerplate to set up FileReader */
            const reader = new FileReader();
            this.setState({ shows: false })
            const rABS = !!reader.readAsBinaryString;

            reader.onload = (e: any) => {
                /* Parse data */
                const bstr = e.target.result;
                const wb = XLSX.read(bstr, { type: rABS ? 'binary' : 'array', bookVBA: true });
                /* Get first worksheet */
                const wsname = wb.SheetNames[0];
                const ws = wb.Sheets[wsname];
                /* Convert array of arrays */
                const data = XLSX.utils.sheet_to_json(ws);
                const data1 = XLSX.utils.sheet_to_json(ws, { header: 1 });
                this.setState({ loading: true })
                // console.error(this.state.loading + "-this set before true")
                const sentdata = {
                    file: this.state.actualFile,
                    checked: false,
                }
                // console.log(data);
                // console.log(data1[0])
                // const data3=data1[0]
                const data2 = ['SalesReportDate', 'IMONumber', 'VesselName', 'FlagName', 'VesselTypeCode', 'BuiltYear', 'DWTDesign', 'GT', 'LDT', 'Seller(BeneficialOwner)', 'Buyer(BeneficialOwner)', 'SalesPrice(USD million)', 'SalesPrice($/Ldt)', 'Destination', 'SaleType', 'DryDockDate', 'SpecialSurveyDate', 'SalesNote', 'PreviousSalesRecord', 'DateModified']
//const data2 = ['SalesReportDate']
                //SalesReportDate	IMONumber	VesselName	FlagName	VesselTypeCode	BuiltYear	DWTDesign	GT	LDT	Seller(BeneficialOwner)	Buyer(BeneficialOwner)	SalesPrice(USD million)	SalesPrice($/Ldt)	Destination	SaleType	DryDockDate	SpecialSurveyDate	SalesNote	PreviousSalesRecord	DateModified

                  console.log(data);
                console.log(data1[0])
                console.log(data2)
                console.log(data.length, 'length')
                // console.log(data1[0].length === data2.length, 'length')
                // console.log(data1[0].length === data2.length, 'length')
                if ((Array.isArray(data1[0]) && Array.isArray(data2) && data1[0].length === data2.length && data1[0].every((val, index) => val === data2[index])) === false) {
                    this.setState({ loading: false })
                    swal("OOPS", String("Header Name Or The Column Count Of The Imported Excel Is Mismatched With The Template"), "error")
                    // window.location.reload();
                } else {
                    if (data.length <= 200) {
                        datalasticShipEngService.addshipDemoExcel(data, false).subscribe({
                            next: (res) => {
                                if (res.success === false) {
                                    swal("OOPS", String(res.msg), "error")
                                } else {
                                    if (res.msg === 'validation success') {
                                        this.setState({
                                            loading: false,
                                            shows: true,
                                            data: res.data
                                        })
                                        // console.error(this.state.loading + "-this set before false")

                                        // if (res.data[0].new_updated_docks === 0) {
                                        //     //swal("Great", "No New Records To Import Data", "success")
                                        // } else {
                                        //     //swal("Great", "DryDock Imported Successfully", "success")
                                        // }
                                    } else {
                                        // console.log(res.data, 'print')
                                        this.setState({
                                            loading: false,
                                            shows: true,
                                            data: res.data
                                            // name:[]
                                        })
                                        // console.error(this.state.loading + "-this set before false")
                                    }
                                }
                            },
                            error: err => {
                                this.setState({ loading: false })
                                swal("OOPS", String(err), "error")
                                console.error(err)
                            }
                        })
                    }
                    else {
                        swal("OOPS", "Total Records must be less than 200 ", "error")
                        window.location.reload();
                    }
                    /* Update state */
                    this.setState({ data: data, cols: make_cols(ws['!ref']) }, () => {
                    });

                }


            };
            if (rABS) {
                reader.readAsBinaryString(this.state.file);
            } else {
                reader.readAsArrayBuffer(this.state.file);
            };
        } else {
            swal("Warning", "Please Select File", "warning")
        }
    }

    reset() {
        window.location.reload();
    }

    uploadFile() {
        console.log(true)
        /* Boilerplate to set up FileReader */
        const reader = new FileReader();
        //this.setState({ shows: false })
        this.setState({ loading: true })
        const rABS = !!reader.readAsBinaryString;

        reader.onload = (e: any) => {
            /* Parse data */
            const bstr = e.target.result;
            const wb = XLSX.read(bstr, { type: rABS ? 'binary' : 'array', bookVBA: true });
            /* Get first worksheet */
            const wsname = wb.SheetNames[0];
            const ws = wb.Sheets[wsname];
            /* Convert array of arrays */
            const data = XLSX.utils.sheet_to_json(ws);
            const data1 = XLSX.utils.sheet_to_json(ws, { header: 1 });
            console.log(data1)

            this.setState({ loading: true })

            const sentdata = {
                input: this.state.data,
                // number_of_valid: this.state.data[0].valid_count,
                checked: true,
            }
            datalasticShipEngService.addshipDemoExcel(data, true).subscribe({
                next: (res) => {
                    this.setState({ loading: false })
                    if (res.data[0].valid_count > 0) {

                        this.setState({ loading: false })
                        swal("Great", "Ship Demolition Imported Successfully", "success")
                        history.push('/datalastic/shipDemo')
                        this.props.onClose('success')
                    } else {
                        this.setState({ loading: false })
                        swal("OOPS", String("No Valid Record To Import"), "error")

                        history.push('/datalastic/shipDemo')
                        this.props.onClose()
                    }

                },
                error: err => {
                    this.setState({ loading: false })
                    swal("OOPS", String(err), "error")
                    console.error(err)
                    history.push('/import/shipDemolition')
                    this.props.onClose()

                }
            })
            /* Update state */
            this.setState({ data: data, cols: make_cols(ws['!ref']) }, () => {
            });

        };
        if (rABS) {
            reader.readAsBinaryString(this.state.file);
        } else {
            reader.readAsArrayBuffer(this.state.file);
        };

    }
    _willDelete = () => {

    }

    render() {

        if (this.state.loading) {
            console.error(this.state.loading + "-loading started")
            console.log(true, '1')
            return <Text center className="loader">
                <Loader
                    type="Rings"
                    color="#233269"
                    height={100}
                    width={100}
                    timeout={30000}
                />
            </Text>
        }
        return (
            <div>
                <Main>
                    <Text className='import-cls' variant="title" color='black'>Import Ship Demolition</Text>
                    {this.state.shows === true ? (
                        <div className="back_button_parent">
                            <Flex jc='jc-end' className='p-1 d-inline back_button'>
                                <Button
                                    block
                                    type="button"
                                    onClick={this.reset}
                                    variant='transparent'>
                                    <Flex>
                                        <Icons icon="arrow_back" />
                                        Back
                                    </Flex>
                                </Button>
                            </Flex>
                        </div>

                    ) : (
                        <>
                        </>
                    )}
                    <Space divheight={25} />
                    <Card>
                        {this.state.shows === false ? (
                            <Grid templateCols='100% auto'>
                                <div className='import-section'>
                                    <Row className='m-0 p-0 upload-btn-container'>
                                        <Col xs='12' md='12' lg='12' xl='12' className='p-0 m-0'>
                                            <Attributes className='singleFrame'>
                                                <a href="https://asset-p2.navidok.com/v2/files/datalystics/Ship_Demolition_template.xlsx"><img src={downloadicon}></img></a>
                                                <Text color='tablehead import-txt' variant='subtitle' bold>Demolition Template as .xls</Text>
                                                <div className="upload-btn-wrapper">
                                                    <Button variant='transparent' block className='fileUpload'>
                                                        <Flex>
                                                            <input type="file" id="file" className="new_input" accept={SheetJSFT} onChange={this.handleChange}
                                                            />
                                                            <Icons color="#ffffff" icon="publish" />
                                                            Choose File
                                                        </Flex>
                                                    </Button>
                                                </div>
                                                {this.state.actualFile != null ? (
                                                    <Text>{this.state.actualFile.name}</Text>
                                                ) : (<Text></Text>)}
                                                <Space divheight={15} />
                                                <Text color='tablehead import-txt d-block mx-auto d-align-center text-center' variant='subtitle' bold>Import ship classification excel before importing the ship Demolition</Text>
                                            </Attributes>
                                        </Col>
                                    </Row>
                                    <Row className='m-0 p-0 upload-btn-container'>
                                        <Col xs='12' md='12' lg='12' xl='12' className='p-0 m-0'>
                                            <Attributes className='singleFrame'>
                                                <Flex jc='jc-center'>
                                                    {/* <Button
                                                    block
                                                    type="button"
                                                    onClick={() => this.props.onClose()}
                                                    variant='transparent'>
                                                    <Flex>
                                                        <Icons icon="clear" />
                                                        Cancel
                                                    </Flex>
                                                </Button> */}
                                                    <Button variant='transparent' block type="submit" onClick={this.handleFile}>
                                                        <Flex>
                                                            <Icons color="#ffffff" icon="publish" />
                                                            Upload File
                                                        </Flex>
                                                    </Button>
                                                </Flex>
                                            </Attributes>
                                        </Col>
                                    </Row>
                                </div>
                            </Grid>
                        ) : (
                            <>
                            </>
                        )}
                    </Card>
                    <Card className='DataShowingContainer'>
                        {this.state.shows === true ? (
                            <>
                                <Text className='DatalysticText'> {/* Display the total elements.   */}
                                    {this.state.data.length === 1 && (
                                        <>
                                            <b>
                                                Total records in the file {this.state.data.length}. Valid records are {this.state.data[0].valid_count}
                                            </b>
                                        </>
                                    )}
                                    {this.state.data.length > 1 && (
                                        <>
                                            <b>
                                                Total records in the file {this.state.data.length}. Valid records are {this.state.data[0].valid_count}
                                            </b>
                                        </>
                                    )}
                                </Text>
                                <Table className="table-import">
                                    <thead>

                                        <tr key={0}>
                                            <th>Sale Date</th>
                                            <th>
                                                IMO Number &nbsp;
                                            </th>
                                            <th>
                                                Ship Name &nbsp;
                                            </th>
                                            <th>
                                                Flag Name
                                            </th>
                                            <th>Built Year &nbsp;</th>
                                            <th>
                                                Ship Type &nbsp;
                                            </th>
                                            {/* <th>
                                                DWT Design &nbsp;
                                            </th>
                                            <th>
                                                gt &nbsp;
                                            </th>
                                            <th>ldt &nbsp;</th> */}
                                            <th>Seller &nbsp;</th>
                                            <th>Buyer &nbsp;</th>
                                            {/* <th>Sales Price Usd &nbsp;</th> */}
                                            <th>Sales Price ($/Ldt) &nbsp;</th>
                                            <th>Destination &nbsp;</th>
                                            {/* <th>Sale Type &nbsp;</th> */}
                                            {/* <th>DryDockDate &nbsp;</th>
                                            <th>Special Survey Date &nbsp;</th> */}
                                            <th>Note &nbsp;</th>
                                            {/* <th>Previous Sale &nbsp;</th> */}
                                            {/* <th>Date Modified &nbsp;</th>
                                            <th>Source Data &nbsp;</th> */}

                                            <th>
                                                Message
                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {this.state.data.map((dock: any, i: any) => [

                                            <tr key={dock.sno}>
                                                <td data-label='Sale Date'>{dock.SalesReportDate}</td>
                                                <td data-label='IMO Number'>{dock.IMONumber}</td>
                                                <td data-label='vessel Name'>{dock.VesselName}</td>
                                                <td data-label='Flag Name'>{dock.FlagName}</td>
                                                <td data-label='Built Year'>{dock.BuiltYear}</td>
                                                <td data-label='vessel Type'>{dock.VesselTypeCode}</td>
                                                {/* <td data-label='DWT Design'>{dock.DWTDesign}</td>
                            
                                                <td data-label='GT'>{dock.GT}</td>
                                                <td data-label='LDT'>{dock.LDT}</td> */}
                                                <td data-label='Seller'>{dock.Seller}</td>
                                                <td data-label='Buyer'>{dock.Buyer}</td>
                                                {/* <td data-label='Sales Price (USD million)'>{dock.SalesPriceUsd}</td> */}
                                                <td data-label='Sales Price ($/Ldt)'>{dock.salesPriceLdt}</td>
                                                <td data-label='Destination'>{dock.Destination}</td>
                                                {/* <td data-label='Type'>{dock.SaleType}</td> */}
                                                {/* <td data-label='DryDockDate'>{dock.DryDockDate}</td>
                                                <td data-label='Special Survey Date'>{dock.SpecialSurveyDate}</td> */}
                                                <td data-label='Note'>{dock.SalesNote}</td>
                                                {/* <td data-label='Previous Sale'>{dock.PreviousSalesRecord}</td> */}
                                                {/* <td data-label='Date Modified'>{dock.DateModified}</td>
                                                <td data-label='Source Data'>{dock.SourceData}</td> */}
                                                <td data-label='Message'>{dock.Message === 'valid' ? (
                                                    <Text color='success' variant='subtitle'>{dock.Message}</Text>
                                                ) : (
                                                    <Text color='danger' variant='subtitle'>{dock.Message}</Text>
                                                )}
                                                </td>

                                            </tr>

                                        ])}

                                    </tbody>

                                </Table>
                                {/* <TableFooter>
                
              </TableFooter> */}

                                <Flex jc='jc-center' className='p-5 m-0'>
                                    <Button
                                        block
                                        type="button"
                                        onClick={this.reset}
                                        variant='transparent'>
                                        <Flex>
                                            <Icons icon="clear" />
                                            Cancel
                                        </Flex>
                                    </Button>
                                    <Button variant='transparent' block type="submit"
                                        onClick={this.uploadFile}>
                                        <Flex>
                                            <Icons color="#ffffff" icon="publish" />
                                            Submit
                                        </Flex>
                                    </Button>
                                </Flex>
                            </>
                        ) : (
                            <>
                                <div className='nodata-txt-container'>
                                    <Text color='tablehead' variant='subtitle' bold>Kindly Import Ship Demolition Data</Text>
                                </div>
                            </>
                        )
                        }
                    </Card>
                </Main>
                {/* <div>
                    <Modal
                        onClose={() => this.props.onClose()}
                        title={'Import Dock Details As Excel'}
                        className='import-mode'>
                        <ModalBody>
                            <Attributes className='singleFrame'>
                                <a href="https://navidok-staging-asset.s3.ap-southeast-1.amazonaws.com/v1/quotations/15_12_2021/dock_template.xlsx"><img src={downloadicon}></img></a>
                                <input type="file" id="file" className="new_input" accept={SheetJSFT}
                                    onChange={this.handleChange} />
                            </Attributes>
                            <Text color='danger' variant='subtitle' bold>Note: Navidok will not import repeated and null records.</Text>
                            <Space divheight={20} />
                            <Flex jc='jc-center'>
                                <Button
                                    block
                                    type="button"
                                    onClick={() => this.props.onClose()}
                                    variant='transparent'>
                                    <Flex>
                                        <Icons icon="clear" />
                                        Cancel
                                    </Flex>
                                </Button>
                                <Button variant='transparent' block type="submit" onClick={this.handleFile}>
                                    <Flex>
                                        <Icons color="#ffffff" icon="publish" />
                                        Upload File
                                    </Flex>
                                </Button>
                            </Flex>
                        </ModalBody>
                    </Modal>
                </div>
                {console.log(this.state.shows, 'shows value')}
                {this.state.shows === true &&
                    <div>
                        <Modal onClose={() => this.props.onClose()} title={'Import Confirmation'} className='import-new-mode'>
                            <ModalBody>
                                <Text bold variant='confirmation' color='danger' values='Want to import the dock details ' />
                                {this.state.data[0].new_dock_type_count !== 0 &&
                                    <>
                                        <p>Total new dock Type - {this.state.data[0].new_dock_type_count}</p>
                                    </>
                                }
                                {this.state.data[0].new_port_count !== 0 &&
                                    <>
                                        <p>Total new Ports - {this.state.data[0].new_port_count}</p>
                                    </>
                                }
                                {this.state.data[0].new_city_count !== 0 &&
                                    <>
                                        <p>Total new City - {this.state.data[0].new_city_count}</p>
                                    </>
                                }
                                {this.state.data[0].new_company_count !== 0 &&
                                    <>
                                        <p>Total new Company - {this.state.data[0].new_company_count}</p>
                                    </>
                                }
                                {this.state.data[0].new_country_count !== 0 &&
                                    <>
                                        <p>Total new Country - {this.state.data[0].new_country_count}</p>
                                    </>
                                }
                                <Table>
                                    <thead>
                                        <tr key={0}>
                                            <th>Dock Name</th>
                                            <th>
                                                Company Name &nbsp;
                                            </th>
                                            <th>
                                                Port &nbsp;
                                            </th>
                                            <th>
                                                Country
                                            </th>
                                            <th>City &nbsp; </th>
                                            <th>
                                                Dock Type &nbsp;
                                            </th>
                                            <th>
                                                Latitude
                                            </th>
                                            <th>
                                                Longitude
                                            </th>
                                            <th>Draft </th>
                                            <th>
                                                Length
                                            </th>
                                            <th>
                                                Width
                                            </th>
                                            <th>
                                                Unit Name
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.data.map((dock: any, i: any) => [
                                            <tr key={dock.sno}>
                                                <td data-label='Dock Name'>{dock.dock_name}
                                                </td>
                                                <td data-label='Company Name'>{dock.company_name}</td>
                                                <td data-label='Port'>{dock.port_name}</td>
                                                <td data-label='Country'>{dock.country_name}</td>
                                                <td data-label='City'>{dock.city_name}</td>
                                                <td data-label='Dock Type'>{dock.dock_type}</td>
                                                <td data-label='Latitude'>{dock.lat}</td>
                                                <td data-label='Longitude'>{dock.lon}</td>
                                                <td data-label='Draft'>{dock.draft}</td>
                                                <td data-label='Length'>{dock.length}</td>
                                                <td data-label='Width'>{dock.width}</td>
                                                <td data-label='Unit Name'>{
                                                    dock.unit_name === null ? (
                                                        <>
                                                            -
                                                        </>
                                                    ) : (
                                                        <>
                                                            {dock.unit_name}
                                                        </>

                                                    )
                                                }</td>
                                            </tr>
                                        ])}
                                    </tbody>
                                </Table>

                                <Flex jc='jc-center'>
                                    <Button
                                        block
                                        type="button"
                                        onClick={() => this.props.onClose()}
                                        variant='transparent'>
                                        <Flex>
                                            <Icons icon="clear" />
                                            Cancel
                                        </Flex>
                                    </Button>
                                    <Button variant='transparent' block type="submit"
                                        onClick={this.uploadFile}>
                                        <Flex>
                                            <Icons color="#ffffff" icon="publish" />
                                            Upload File
                                        </Flex>
                                    </Button>
                                </Flex>
                            </ModalBody>
                        </Modal>
                    </div>
                } */}
            </div>
        )
    }
}

export interface TablefooterProps {
    children?: React.ReactNode
}

// Table footer style.   
const TableFooter = (props: TablefooterProps) => {

    const tablefooter = classNames('tablefooter')

    return (
        <Flex jc='jc-between' className={tablefooter}>
            {props.children}
        </Flex>
    )

}
export default DatalasticExcel;

const SheetJSFT = [
    "xlsx", "xlsb", "xlsm", "xls", "xml", "csv", "txt", "ods", "fods", "uos", "sylk", "dif", "dbf", "prn", "qpw", "123", "wb*", "wq*", "html", "htm"
].map(function (x) { return "." + x; }).join(",");
